import React from "react";
import Page from "../../common/page/Page";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized";
import RecruiterListBlock from "./RecruiterListBlock";


export default function RecruiterListPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "RecruiterListPage");

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="RecruiterListPage">
          <Page.Title
            text={t("admin:admin_recruiter_list_title")}
            loading={tLoading}
          />
          <Page.Content>
            <RecruiterListBlock />
          </Page.Content>
        </Page>
      )}
    />
  );
}
